import { Track } from '../types';
import { trackStore } from '../services/trackStore';

export const loadTracks = async (): Promise<Track[]> => {
  const dtos = await trackStore.getAll();
  return dtos.map((dto) => ({
    id: dto.id,
    name: dto.name,
    audioFile: (() => {
      const f = dto.audioFile;
      if (!f) {
        // Fallback: use the track name as the filename (URL-encode spaces etc.)
        return `/tracks/${encodeURIComponent(dto.name)}.mp3`;
      }
      // If it already looks like an absolute path or URL leave it alone
      if (f.startsWith('/') || f.startsWith('http')) return f;
      // Bare filename — prefix with /tracks/ and encode it
      return `/tracks/${encodeURIComponent(f)}`;
    })(),
    youtubeId: dto.youtubeId ?? undefined,
    metadata: {
      bpm: dto.bpm,
      defaultPitchShift: dto.defaultPitchShift,
      parts: dto.parts.map((p) => ({
        title: p.title,
        startTime: p.startTime,
        stopTime: p.stopTime,
        bpmOverride: p.bpmOverride ?? undefined,
      })),
      links: dto.links.map((l) => ({ title: l.title, url: l.url })),
    },
  }));
};
